import { render, staticRenderFns } from "./SubTerms.vue?vue&type=template&id=1b3f1816&scoped=true&"
import script from "./SubTerms.vue?vue&type=script&lang=js&"
export * from "./SubTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f1816",
  null
  
)

export default component.exports